import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthContextProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { PostProvider } from './context/PostContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter
    future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
  >
    <AuthContextProvider>
      <PostProvider>
        <App />
      </PostProvider>
    </AuthContextProvider>
  </BrowserRouter>
);
